import { useEffect, useState } from 'react';
import { loadVideoConfiguration } from '../services/video-configuration';

export function useVideoConfiguration(id: string | null) {
  const [configuration, setConfiguration] = useState<Awaited<ReturnType<typeof loadVideoConfiguration>>>();
  const [error, setError] = useState('');
  const [attempt, setAttempt] = useState(0);
  useEffect(() => {
    if (!id) return;
    let active = true;
    setConfiguration(undefined); setError('');
    void loadVideoConfiguration(id).then(value => { if (active) setConfiguration(value); })
      .catch(cause => { if (active) setError(cause instanceof Error ? cause.message : 'Unable to reopen this video.'); });
    return () => { active = false; };
  }, [id, attempt]);
  return { configuration, error, retry: () => setAttempt(value => value + 1) };
}
